<div class="row">
  <div class="col-12 text-center">
    <img [src]="src | safe: 'resourceUrl'" />
  </div>
</div>
